import {ArrowUpRight, Clapperboard, FileText, Globe2, Layers, UserRound, UsersRound, Scale, Check} from 'lucide-react';
import type {RefObject} from 'react';
import './participant-preparation.css';

export type PreparationArea = {
  key:string;
  title:string;
  description:string;
  status:string;
  complete?:boolean;
  kind:'passport'|'profile'|'personal'|'production'|'immigration'|'legal'|'family'|'documents';
};

function AreaArtwork({kind}:{kind:PreparationArea['kind']}) {
  if(kind==='passport') return <span className="preparation-art preparation-passport" aria-hidden="true"><span className="preparation-passport-book"><Globe2 size={21} strokeWidth={1.2}/><span>PASSPORT</span></span></span>;
  if(kind==='profile') return <span className="preparation-art preparation-profile" aria-hidden="true"><span className="preparation-profile-paper"><span/><span/><span/></span><span className="preparation-profile-folder"><Layers size={19} strokeWidth={1.4}/></span></span>;
  const Icon={personal:UserRound,production:Clapperboard,immigration:Globe2,legal:Scale,family:UsersRound,documents:FileText}[kind];
  return <span className="preparation-art preparation-symbol" aria-hidden="true"><Icon size={29} strokeWidth={1.5}/></span>;
}

export function ParticipantPreparation({areas,onOpen,profileRef,locale}:{areas:PreparationArea[];onOpen:(key:string)=>void;profileRef:RefObject<HTMLButtonElement|null>;locale:'en'|'es'}) {
  return <section className="preparation-grid" aria-label={locale==='es'?'Secciones para completar':'Sections to complete'}>
    {areas.map(area=><button key={area.key} ref={area.kind==='profile'?profileRef:undefined} type="button" className={`preparation-area preparation-area-${area.kind}`} onClick={()=>onOpen(area.key)} aria-label={area.title} aria-describedby={`preparation-description-${area.key} preparation-status-${area.key}`}>
      <span className="preparation-area-top"><AreaArtwork kind={area.kind}/><ArrowUpRight className="preparation-entry-arrow" size={18} aria-hidden="true"/></span>
      <span className="preparation-area-title">{area.title}</span>
      <span className="preparation-area-description" id={`preparation-description-${area.key}`}>{area.description}</span>
      <span className={`preparation-area-status${area.complete?' is-provided':''}`} id={`preparation-status-${area.key}`}>{area.complete&&<Check size={14} aria-hidden="true"/>}{area.status}</span>
    </button>)}
  </section>;
}
